import React from 'react';
import { Configure, InstantSearch } from 'react-instantsearch-core';
import algoliasearch from 'algoliasearch/lite';
import { styled } from 'styled-components';
import AlgoliaAutocomplete from './AlgoliaAutocomplete';
import NavCustomSearchResults from './NavCustomSearchResults';

const searchClient = algoliasearch(process.env.ALGOLIA_APP_ID || '', process.env.ALGOLIA_SEARCH_KEY || '');

const AlgoliaSearch: React.FC = () => {
  return (
    <Wrapper>
      <InstantSearch searchClient={searchClient} indexName={process.env.ALGOLIA_INDEX_NAME || ''}>
        <Configure hitsPerPage={500} />
        <AlgoliaAutocomplete searchClient={searchClient} />
        <NavCustomSearchResults />
      </InstantSearch>
    </Wrapper>
  );
};

export default AlgoliaSearch;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
